import api from "../api/api";

//get all car catagory
export const getCatagory=async()=>{
    try {
        const reponse=await api.get("/categories/");
        return reponse.data;
        
    } catch (error) {
        console.log(error);
        return error
    }
}
//get all cars
export const getCars=async()=>{
    try {
        const reponse=await api.get("/cars/");
        return reponse.data;
    } catch (error) {
        console.log(error);
        return error
    }
}
export const getCarBookings=async(userID)=>{
    try {
        const reponse=await api.get("/bookings/",{params:{
            userID,
            bookingType:'car'
        }});
        return reponse.data;
    } catch (error) {
        console.log(error);
        return error
    }
}